
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import Axios from "axios";

export default function DanhSachQuanLyProfile() {
    const { user } = useSelector((state) => state.auth);
    const [params, setParam] = useState('');
    const [fullname, setFullname] = useState();

    const [filterShow, setFilterShow] = useState(false)

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = ''
        if (fullname !== '') _param += "&fullname=" + fullname

        setParam(_param);
    };


    let columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "fullname", label: "Họ tên" },
        { name: "part_title", label: "Phòng ban" },
        { name: "company", label: "Công ty" },
        { name: "author_name", label: "Người tạo" },
        {
            name: "position", label: "Thứ tự Hiển thị",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <div className="form-group" style={{ minWidth: 100 }}>
                        <input className="form-control form-control-sm height32" type="number" defaultValue={value} onBlur={(e) => updatePosition(tableMeta.id, e.target.value)} />
                    </div>
                },
            }
        },
        { name: "datecreate", label: "Ngày tạo" },
        { name: "datemodified", label: "Ngày sửa" },
    ];
    const updatePosition = (tbid, value) => {
        Axios.put(URL_LIST_ALL + 'learninghub_profiles/' + tbid, { position: value }, user.config).then(res => {
            if (res.data.status === "success") {
                
            } else {
                confirmAlert({
                    title: 'Lỗi',
                    message: res.data.message,
                    buttons: [{ label: 'OK' }]
                });
            }
        }).catch(err => console.log(err));
    }

    return (<AkkhorLayout idrole="learning_profile_manager">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Quản lý Profile
                </li>
            </ul>
        </div>
        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto">
                        <h3 className="title">Tìm kiếm</h3>
                    </div>
                    <button className="btn btn-sm btn-defaul" onClick={() => setFilterShow(!filterShow)}><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get" >
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
                            <label>Họ tên</label>
                            <input type="text" placeholder="Họ tên" value={fullname} onChange={(e) => setFullname(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>
                        <div className="col-12 ">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SRList name="learninghub_profiles" linkaction="learninghub_profiles" idrole="learning_profile_manager" params={params} defaultLimit={50} serverSide={true} columns={columns} ></SRList>
    </AkkhorLayout>);
}
